import { ReactNode } from "react";
import InteractionGate from "@/components/ui/InteractionGate";

interface Props {
  children: ReactNode;
  /** Reserve the same vertical space as the real panel to avoid layout shift. */
  placeholder?: ReactNode;
  /** Deprecated compatibility prop; automatic reveal is disabled. */
  loadIdleMs?: number;
}

/**
 * Mobile-only gate for the homepage search/filter panel.
 *
 * The panel is heavy (icons, slider, live search). On mobile we defer its
 * render until genuine visitor engagement.
 *
 * While hidden, a same-height placeholder is rendered so the swap is CLS-free.
 */
export default function MobileSearchPanelGate({
  children,
  placeholder,
}: Props) {
  return <InteractionGate placeholder={placeholder}>{children}</InteractionGate>;
}
